import { RootState } from "@/store";
import { wizardProgress } from "@/utils/wizardProgress";
import { useSelector } from "react-redux";

interface UseWizardProgressProps {
  saveProgress: (stepNumber: number) => void;
  getStartingStep: (isModal?: boolean) => number;
  clearProgress: () => void;
  saveTermsAcceptance: (accepted: boolean) => void;
  isTermsAccepted: () => boolean;
  resetProgress: () => void;
  progress: {
    lastCompletedStep: number;
    terms_accepted: boolean;
  };
}

export const useWizardProgress = (): UseWizardProgressProps => {
  const userID = useSelector((state: RootState) => state.user.id);

  const saveProgress = (stepNumber: number) => {
    wizardProgress.saveStepProgress(stepNumber, userID);
  };

  const getStartingStep = (isModal: boolean = false) => {
    return wizardProgress.getStartingStep(isModal, userID);
  };

  const clearProgress = () => {
    wizardProgress.clearProgress(userID);
  };
  const saveTermsAcceptance = (accepted: boolean) => {
    wizardProgress.saveTermsAcceptance(accepted, userID);
  };

  const isTermsAccepted = () => {
    return wizardProgress.isTermsAccepted(userID);
  };

  const resetProgress = (): void => {
    wizardProgress.resetProgress(userID);
  };

  return {
    saveProgress,
    getStartingStep,
    clearProgress,
    saveTermsAcceptance,
    isTermsAccepted,
    resetProgress,
    progress: userID
      ? wizardProgress.getProgress(userID)
      : { lastCompletedStep: 0, terms_accepted: false },
  };
};
